import { includes, some } from 'lodash';
import React, { useMemo } from 'react';
import CommunicationLogTypeModel from '../../../../model/CommunicationLogType';
import { LOG } from '../../../../model/CommunicationType';
import useEnumerableModel from '../../../data/hooks/useEnumerableModel';
import itemIdValue from '../../../itemIdValue';
import useT from '../../utils/Translations/useT';
import MultiselectFilter from './MultiselectFilter';
var get = Reflect.get;
const CommunicationLogType = ({ filter, value, ...rest }) => {
    const t = useT();
    const { options } = useEnumerableModel(CommunicationLogTypeModel);
    const hasNoCommunicationTypes = useMemo(() => !!(filter === null || filter === void 0 ? void 0 : filter.hasOwnProperty('communicationType')) &&
        !some(get(filter, 'communicationType'), type => includes([LOG.value], type)), [filter]);
    const values = useMemo(() => (hasNoCommunicationTypes ? [] : value), [
        value,
        hasNoCommunicationTypes,
    ]);
    return (<MultiselectFilter {...rest} disabled={hasNoCommunicationTypes} filter={filter} itemId={itemIdValue} options={options} title={t('Log Type')} value={values}/>);
};
export default CommunicationLogType;
